import uiConfig from 'src/lib/ui/config';
import { ImageCoverView } from '@play-co/timestep-core/ui';
import ResponsiveScene from './ResponsiveScene';
import { Transition } from 'src/game/logic/SceneManager';
import { AssetGroup } from '@play-co/timestep-core';

export default class BathroomScene extends ResponsiveScene {
  constructor() {
    super(
      new ImageCoverView({
        ...uiConfig.buruburu.backgroundDefaults,
        ...uiConfig.buruburu.bathroom,
      }),
    );

    this.getView().tag = 'bathroom';

    this.addBath();
  }

  public async preload() {
    await new AssetGroup(
      AssetGroup.constructURLs(['assets/ui/bathroom/']),
    ).load();
  }

  private addBath() {
    const scene = this.getView();
    scene.addSubview(new ImageCoverView(uiConfig.buruburu.bathroomBathTop));
    scene.addSubview(new ImageCoverView(uiConfig.buruburu.bathroomBathFront));
  }

  public transition(): Transition {
    return 'slide_forward';
  }
}
